module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjcwMiA1LjJINC4zMDVMNy4xOSAyLjIyYTEuMzE4IDEuMzE4IDAgMDAwLTEuODM5IDEuMjI2IDEuMjI2IDAgMDAtMS43MzYtLjA0bC0uMDQxLjA0LTUuMDM4IDUuMmExLjMxNiAxLjMxNiAwIDAwMCAxLjgzOGw1LjAzOCA1LjJhMS4yMjYgMS4yMjYgMCAwMDEuNzc2IDAgMS4zMTYgMS4zMTYgMCAwMDAtMS44MzhsLTIuODg0LTIuOThoMTAuMzk3YTEuMyAxLjMgMCAwMC4wMDEtMi42MDIiIGZpbGw9IiM2NjYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mycourses/BackButtonHover.svg
// module id = 1723
// module chunks = 0